<template>
  <div class="document" style="height:100%">
    <div class="header">
      <EsHeader>
        <template #header>
          <div class="header-title">Download Options</div>
        </template>
      </EsHeader>
    </div>
    <div class="content">
      <es-loader v-if="this.parentPage.loading === true"/>
      <div v-else>
        <dm-download-match-status
          v-if="!showForSearch && dmobjmatch"
          :dmobjmatch="dmobjmatch"
          :matchStatusOptions.sync="matchStatusOptions"
          :categories="categories"
        />
        <dm-download-format
          v-if="showForSearch || showForBatches || showForTransactions"
          :allowedExtractDownloadTypes="allowedExtractDownloadTypes"
          :categories="categories"
          :formatOptions.sync="formatOptions"
          :matchStatusOptions="matchStatusOptions"
          :notSearch="parentPage.notSearch"
        />
      </div>
      <div
        class="is-flex flex-align--center flex-justify--end"
        style="margin: 0 3rem 0 4rem; padding: 1rem 0"
      >
        <div v-if="isStateBatch" class="is-flex grow has-text-left">
          Note: A State Batch download may include one or many records for each transaction for Canceled, No Match and {{ this.properties['SYSTEM_LABEL-NEARMATCH'] }} downloads.
        </div>
        <button v-if="hasModule('DRMCH:DWNLD:DOWNLOAD') && (showForSearch || showForBatches || showForTransactions)"
          class="button is-primary"
          @click="generateExtract()"
        >
          Generate Extract
        </button>

      </div>
    </div>
    <es-loader v-if="parentPage.notSearch && !dmobjmatch" />
  </div>
</template>
<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import DmDownloadMatchStatus from '@/components/DmDownloadMatchStatus.vue';
import DmDownloadFormat from '@/components/DmDownloadFormat.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import DateUtils from '@/mixins/DateUtils';
import PermissionManager from '@/mixins/PermissionManager';
import { mapGetters } from 'vuex';

library.add(
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
);

export default {
  components: {
    DmDownloadMatchStatus,
    DmDownloadFormat,
    EsHeader,
    EsLoader,
  },
  mixins: [DateUtils, PermissionManager],
  props: [
    'dmobj',
    'dmobjid',
    'dmobjmatch',
    'parentPage',
  ],
  data() {
    return {
      categories: [],
      matchStatusOptions: {
        matchStatusSelect: null,
      },
      formatOptions: {
        dmatchFileFormat: null,
        delimiter: 'TAB',
        qualifier: 'NONE',
        includeHF: false,
        dateFormat: 'MM/dd/yyyy',
      },
      fileExt: null,
      statDesc: null,
      dateObj: null,
    };
  },
  mounted() {
    if (this.parentPage.notSearch) {
      this.groupedCategories();
    }
    const defFileFormat = this.getProperty('DIRECTMATCH-DEFAULT_EXTRACT_TEMPLATE');
    this.formatOptions.dmatchFileFormat = defFileFormat.toLowerCase();
  },
  methods: {
    groupedCategories() {
      const matchType = {};
      const matchCategories = [];
      [1, 14, 16].forEach((code) => { matchType[code] = 'Match'; });
      [4, 15].forEach((code) => { matchType[code] = 'No Match'; });
      [13, 17, 90].forEach((code)  => { matchType[code] = 'Canceled'; });
      [2].forEach((code) => { matchType[code] = 'Near Match'; });
      // Near Match system label needed
      this.dmobjmatch.matchStats.forEach((item) => {
        const categorySection = matchCategories.find(x => x.name === matchType[item.matchStatusCode]);
        if (!categorySection) {
          if (matchType[item.matchStatusCode] === 'Match') {
            matchCategories.push({
              name: matchType[item.matchStatusCode],
              data: [
                {
                  name: item.matchStatusDesc,
                  statusCount: item.count,
                  statType: item.statType,
                  matchDate: item.matchDate,
                  recordCount: this.dmobjmatch.recordCount,
                  groupCount: item.userMatchCount,
                },
              ]});
          } else if (matchType[item.matchStatusCode] === 'No Match') {
            matchCategories.push({
              name: matchType[item.matchStatusCode],
              data: [
                {
                  name: item.matchStatusDesc,
                  statusCount: item.count,
                  statType: item.statType,
                  matchDate: item.matchDate,
                  recordCount: this.dmobjmatch.recordCount,
                  groupCount: item.userNoMatchCount,
                },
              ],
            });
          } else if (matchType[item.matchStatusCode] === 'Canceled') {
            matchCategories.push({
              name: matchType[item.matchStatusCode],
              data: [
                {
                  name: item.matchStatusDesc,
                  statusCount: item.count,
                  statType: item.statType,
                  matchDate: item.matchDate,
                  recordCount: this.dmobjmatch.recordCount,
                  groupCount: item.userCancelCount,
                },
              ],
            });
          } else if (matchType[item.matchStatusCode] === 'Near Match') {
            matchCategories.push({
              name: matchType[item.matchStatusCode],
              data: [
                {
                  name: item.matchStatusDesc,
                  statusCount: item.count,
                  statType: item.statType,
                  matchDate: item.matchDate,
                  recordCount: this.dmobjmatch.recordCount,
                  groupCount: item.userNearMatchCount,
                },
              ],
            });
          }
        } else {
          categorySection.data.push({
            name: item.matchStatusDesc,
            statusCount: item.count,
            statType: item.statType,
            matchDate: item.matchDate,
            recordCount: this.dmobjmatch.recordCount,
            groupCount: -1,
          });
        }
      });
      this.categories = matchCategories.filter(x => x.name !== undefined);
      if (!this.matchStatusOptions.matchStatusSelect) {
        try {
          this.matchStatusOptions.matchStatusSelect = this.categories[0].data[0].statType;
        } catch (e) {
          // handle error
        }
      }
    },
    getStatDesc(statType) {
      if (statType === '1' || statType === '14' || statType === '16') {
        this.statDesc = 'MCH';
      } else if (statType === '2') {
        this.statDesc = 'PNM';
      } else if (statType === '4' || statType === '15') {
        this.statDesc = 'NOM';
      } else if (statType === '13' || statType === '17') {
        this.statDesc = 'CAN';
      } else {
        this.statDesc = 'SEARCH';
      }
    },
    mappedMatchType(programCode) {
      if (programCode) {
        const programs = this.indexProgramsNonDCX.find(p => p.code === programCode);
        if (programs) {
          return programs.description;
        }
      } return programCode;
    },
    async generateExtract() {
      try {
        this.parentPage.loadingExtract = true;
        this.parentPage.userEmail = this.user.email;
        this.parentPage.userId = this.user.id;
        this.parentPage.matchStatusSelect = this.matchStatusOptions.matchStatusSelect;

        this.getStatDesc(String(this.matchStatusOptions.matchStatusSelect));

        this.fileExt = this.formatOptions.delimiter;

        if (this.fileExt === 'COMMA') {
          this.fileExt = 'CSV';
        }
        const millVal = Date.now();
        this.parentPage.extractDate = (new Date(millVal));
        const millStr = String(millVal);
        const millStrSub = String(millVal).slice(millStr.length - 3);

        this.dateObj = this.createDateObject(this.parentPage.extractDate);

        // extract parts as local variables
        const {
          year,
          month,
          day,
          hour,
          minute,
          second,
        } = this.dateObj;

        if (this.parentPage.notSearch) {
          this.parentPage.extractName = `${this.createExtractFileNameWithDateTime(this.dmobj.program.description, this.dmobj.profileHeader.submissionType, this.dmobjid, this.parentPage.extractDate, millStrSub, this.statDesc)}`;
        } else {
          let statStr = '';
          const valueStr = this.parentPage.programs[0];
          //statStr = valueStr;
          statStr = this.mappedMatchType(valueStr);

          // if (valueStr === "S") {
          //   statStr = "SNAP";
          // } else if (valueStr === "N") {
          //   statStr = "TANF";
          // } else if (valueStr === "MED") {
          //   statStr = "MEDICAID";
          // } else if (valueStr === "F") {
          //   statStr = "FOSTER";
          // }

          this.parentPage.extractName = `${this.createExtractFileNameWithDateTime(statStr, '', '', this.parentPage.extractDate, millStrSub, 'SEARCH')}`;
        }

        this.parentPage.extractNameExt = `.${this.fileExt}`;

        let sourceCodeStr = null;
        if (this.parentPage.notSearch) {
          sourceCodeStr = this.dmobj.sourceCode;
        }

        const res = await axios.post(this.parentPage.url, ({
          id: this.dmobjid,
          fileFormat: this.formatOptions.dmatchFileFormat,
          delimiter: this.formatOptions.delimiter,
          qualifier: this.formatOptions.qualifier,
          dateFormat: this.formatOptions.dateFormat,
          includeHF: this.formatOptions.includeHF,
          matchStatusSelect: this.matchStatusOptions.matchStatusSelect,
          userId: this.parentPage.userId,
          userEmail: this.parentPage.userEmail,
          extractFileName: this.parentPage.extractName,
          extractFileNameExt: this.parentPage.extractNameExt,
          year: year,
          month: month,
          day: day,
          hours: hour,
          minutes: minute,
          seconds: second,
          statDesc: this.statDesc,
          studentId: this.parentPage.studentId,
          districtSchools: this.parentPage.districtSchools,
          districts: this.parentPage.districts,
          schools: this.parentPage.schools,
          programs: this.parentPage.programs,
          schoolYear: this.parentPage.schoolYear,
          source: sourceCodeStr,
        }));
        this.parentPage.linkageId = res.data;
        this.parentPage.extractInfo = null;
      } catch (e) {
        console.log(e);
      } finally {
        this.parentPage.loadingExtract = false;
      }
      this.parentPage.showExtract = true;
    },
  },
  filters: {

  },
  computed: {
    ...mapGetters([
      'user',
    ]),
    ...mapGetters('lookups', [
      'indexProgramsNonDCX',
    ]),
    ...mapGetters('propertiesModule', [
      'getProperty',
    ]),
    allowedExtractDownloadTypes() {
      return this.getProperty('DIRECTMATCH-EXTRACT_DOWNLOAD_TYPES_ALLOWED');
    },
    showForBatches() {
      if (this.parentPage.url.includes('batches')
        && this.dmobjmatch
        && this.dmobjmatch.matchStats.length) {
        return true;
      }
      return false;
    },
    showForSearch() {
      return !this.parentPage.notSearch;
    },
    showForTransactions() {
      if (this.parentPage.url.includes('transactions')
        && this.dmobjmatch.matchStats.length
        && this.dmobjmatch.matchStats[0].description !== 'Error') {
        return true;
      }
      return false;
    },
    isStateBatch() {
      // check to see if state transaction or state batch
      if (this.dmobj
        && this.dmobj.matchTypeId === 34) {
        return true;
      }
      return false;
    },
  },
};
</script>
